import { Component, OnInit, ViewChild, Output, EventEmitter, Input, AfterContentInit } from '@angular/core';
import { PlatformLocation } from '@angular/common';
import { NgbActiveModal, NgbTypeahead, NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subject, merge, OperatorFunction } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map } from 'rxjs/operators';
import { MajorsService, InstitutesService, AuthService, CandidatesService, CountriesService, SpecilizationsService } from '../../../../services';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-education-modal',
    templateUrl: './education-modal.html',
    styleUrls: ['./education-modal.scss']
})

export class EducationModalComponent implements OnInit {
    @ViewChild('instanceMajor', { static: false }) Major_instance: NgbTypeahead;
    @ViewChild('instanceIns', { static: false }) Institute_instance: NgbTypeahead;
    @ViewChild('instanceCountry', { static: false }) Country_instance: NgbTypeahead;
    @ViewChild('instanceSpec', { static: false }) Spec_instance: NgbTypeahead;
    @Output() notifyParent = new EventEmitter<any>();
    @Input() isEdit = false;
    @Input() Education = {
        id: null,
        start_date: null,
        end_date: null,
        institute: null,
        institute_id: null,
        institute_name: null,
        major: null,
        major_name: null,
        major_id: null,
        specilization: null,
        specilization_name: null,
        specilization_id: null,
        country: null,
        country_id: null,
        degree: null,
        graduation_avg: null,
        is_present: false,
    }
    checkConfirm: false;
    majors = [];
    institutes = [];
    countries = [];
    specilizations = [];
    isLoading = false;
    _maxDate = new Date();
    maxDate = { year: this._maxDate.getFullYear(), month: this._maxDate.getMonth() + 1, day: this._maxDate.getDate() }
    country_object = null;
    constructor(private toastr: ToastrService, private countriesService: CountriesService, private candidatesService: CandidatesService, private authService: AuthService, private location: PlatformLocation, public activeModal: NgbActiveModal, private majorSerivce: MajorsService, private instituteSer: InstitutesService, private specService: SpecilizationsService) {
        location.onPopState(() => { this.activeModal.close(); });
    }

    ngAfterContentInit() {
        if (this.isEdit && this.Education.start_date) {
            const temp1 = new Date(this.Education.start_date)
            this.Education.start_date = { year: temp1.getFullYear(), month: temp1.getMonth() + 1, day: temp1.getDate() };
        }
        if (this.isEdit && this.Education.end_date) {
            const temp2 = new Date(this.Education.end_date)
            this.Education.end_date = { year: temp2.getFullYear(), month: temp2.getMonth() + 1, day: temp2.getDate() };
        }
    }

    ngOnInit() {
        this.majorSerivce.getAll().subscribe((res: any) => { this.majors = res.data; });
        this.instituteSer.getAll().subscribe((res: any) => { this.institutes = res.data; });
        this.countriesService.getAll().subscribe((res: any) => { this.countries = res.data; });
        this.specService.getAll().subscribe((res: any) => { this.specilizations = res.data; });
    }

    closeModal() {
        this.activeModal.close({ status: true });
    }

    canAdd() {
        return this.isLoading || this.Education.country == null || (this.Education.start_date == null || (this.Education.end_date == null && !this.Education.is_present) ||
            (this.Education.institute == null && this.Education.institute_name == null) ||
            (this.Education.major == null) || this.Education.degree == null || this.Education.graduation_avg == null) || (this.checkConfirm == false);
    }

    updateUserProfile() {
        this.Education.institute_id = this.Education.institute?.id
        this.Education.major_id = this.Education.major?.id
        this.Education.country_id = this.Education.country?.id
        this.Education.specilization_id = this.Education.specilization?.id
        if (!this.Education.specilization_name && this.Education.specilization)
            this.Education.specilization_name = this.Education.specilization?.spec_name_en;

        var _edu = Object.assign({}, this.Education);
        _edu.start_date = this.Education.start_date.year + "-" + this.Education.start_date.month + "-" + this.Education.start_date.day
        if (!this.Education.is_present)
            _edu.end_date = this.Education.end_date.year + "-" + this.Education.end_date.month + "-" + this.Education.end_date.day
        else
            _edu.end_date = null;
        // Backend expects keys spelled as specilzation_*
        if (_edu.hasOwnProperty('specilization_id')) {
            _edu['specilzation_id'] = _edu['specilization_id'];
            delete _edu['specilization_id'];
        }
        if (_edu.hasOwnProperty('specilization_name')) {
            _edu['specilzation_name'] = _edu['specilization_name'];
            delete _edu['specilization_name'];
        }
        this.isLoading = true;
        if (!this.isEdit)
            this.candidatesService.addEducation(_edu, this.authService.user.candidate?.id).subscribe((res: any) => {
                this.isLoading = false;
                this.notifyParent.emit(true);
                this.Education = {
                    id: null,
                    start_date: null,
                    end_date: null,
                    institute: null,
                    institute_id: null,
                    institute_name: null,
                    major: null,
                    major_name: null,
                    major_id: null,
                    specilization: null,
                    specilization_name: null,
                    specilization_id: null,
                    country: null,
                    country_id: null,
                    degree: null,
                    graduation_avg: null,
                    is_present: false
                }
                this.closeModal();
            }, (error: any) => {
                this.isLoading = false;
                this.toastr.error(error.statusText, "update profile information");
            });
        else
            this.candidatesService.updateEducation(_edu, this.authService.user.candidate?.id, this.Education.id).subscribe((res: any) => {
                this.isLoading = false;
                this.Education = res.data;
                this.notifyParent.emit(true);
                this.closeModal();
            }, (error: any) => {
                this.isLoading = false;
                this.toastr.error(error.statusText, "update profile information");
            });
    }

    formatter = (major: any) => major.major_name_en;
    focus$ = new Subject<string>();
    click$ = new Subject<string>();
    search: OperatorFunction<string, readonly { id, major_name_en }[]> = (text$: Observable<string>) => {
        text$.pipe(debounceTime(200), distinctUntilChanged());
        const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());
        const clicksWithClosedPopup$ = this.click$.pipe(filter(() => !this.Major_instance.isPopupOpen()));
        const inputFocus$ = this.focus$;

        return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(map(term => (term === '' ? this.majors
            : this.majors.filter(major => new RegExp(term, 'mi').test(major.major_name_en) || new RegExp(term, 'mi').test(major.major_name_ar))))
        )
    }

    selectMajor() {
        this.Education.major_name = (typeof this.Education.major == 'string') ? this.Education.major : null;
    }

    spec_formatter = (spec: any) => spec.spec_name_en;
    spec_focus$ = new Subject<string>();
    spec_click$ = new Subject<string>();
    spec_search: OperatorFunction<string, readonly { id, spec_name_en }[]> = (text$: Observable<string>) => {
        text$.pipe(debounceTime(200), distinctUntilChanged());
        const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());
        const clicksWithClosedPopup$ = this.spec_click$.pipe(filter(() => !this.Spec_instance.isPopupOpen()));
        const inputFocus$ = this.spec_focus$;

        return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(
            map(term => (term === '' ? this.specilizations
                : this.specilizations.filter(spec => new RegExp(term, 'mi').test(spec.spec_name_en) || new RegExp(term, 'mi').test(spec.spec_name_ar))))
        );
    }

    selectSpec() {
        if (typeof this.Education.specilization === 'string') {
            this.Education.specilization = null;
            this.Education.specilization_name = null;
            this.Education.specilization_id = null;
        } else {
            this.Education.specilization_name = this.Education.specilization?.spec_name_en || null;
        }
    }

    _formatter = (institute: any) => institute.institute_name_en || institute;
    _focus$ = new Subject<string>();
    _click$ = new Subject<string>();
    _search: OperatorFunction<string, readonly { id, institute_name_en }[]> = (text$: Observable<string>) => {
        text$.pipe(debounceTime(200), distinctUntilChanged());
        const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());
        const clicksWithClosedPopup$ = this._click$.pipe(filter(() => !this.Institute_instance.isPopupOpen()));
        const inputFocus$ = this._focus$;
        //text$.pipe().subscribe(value => this.Education.institute_name = value);

        return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(map(term => (term === '' ? this.institutes.slice(0, 10)
            : this.institutes.filter(institute => new RegExp(term, 'mi').test(institute.institute_name_en) || new RegExp(term, 'mi').test(institute.institute_name_ar)).slice(0, 10)))
        )
    }

    selectInstitute() {
        this.Education.institute_name = (typeof this.Education.institute == 'string') ? this.Education.institute : null;
    }

    country_formatter = (country: any) => country.country_name_en;
    country_focus$ = new Subject<string>();
    country_click$ = new Subject<string>();
    country_search: OperatorFunction<string, readonly { id, country_name_en }[]> = (text$: Observable<string>) => {
        text$.pipe(debounceTime(200), distinctUntilChanged());
        const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());
        const clicksWithClosedPopup$ = this.country_click$.pipe(filter(() => !this.Country_instance.isPopupOpen()));
        const inputFocus$ = this.country_focus$;

        return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(map(term => (term === '' ? this.countries
            : this.countries.filter(country => new RegExp(term, 'mi').test(country.country_name_en)).slice(0, 10)))
        )
    }

    resetDate() {
        this.Education.end_date = null;
    }
}
